import { field } from "../modules/pages/formbuilder/global.model";

export class TemplatesFakeDb {
  public static templates = [
    {
      uuid: "2342323532352",
      name: "Assessment Template 1",
      description: "Assessment Template 1 Description"
    },
    {
      uuid: "234223282392",
      name: "Assessment Template 2",
      description: "Assessment Template 2 Description"
    }
  ];

  public static emptySection = {
    name: "",
    description: "",
    id: "",
    conditional: {
      isConditional: false,
      conditionalText: "",
      conditionalValues: [
        {
          label: "yes",
          value: true
        },
        {
          label: "no",
          value: false
        }
      ]
    },
    attributes: []
  };

  public static defaultFields: Array<field> = [
    {
      type: "text",
      icon: "text_fields",
      label: "Text",
      description: "",
      placeholder: "",
      regex: "",
      required: false,
      validation: false
    },
    {
      type: "email",
      icon: "alternate_email",
      required: true,
      label: "Email",
      description: "Enter a valid email address",
      placeholder: "",
      errorText: "Please enter a valid email",
      validation: true
    },
    {
      type: "phone",
      icon: "phone",
      label: "Phone",
      description: "Enter your phone number including country code",
      placeholder: "",
      errorText: "Please enter a valid phone number",
      required: false,
      validation: false
    },
    {
      type: "number",
      label: "Number",
      icon: "dialpad",
      description: "",
      placeholder: "",
      min: 0,
      max: 100,
      required: false,
      validation: false
    },
    {
      type: "date",
      icon: "calendar_month",
      label: "Date",
      placeholder: "",
      required: false,
      validation: false
    },
    {
      type: "time",
      icon: "schedule",
      label: "Time",
      placeholder: "",
      required: false,
      validation: false
    },

    {
      type: "textarea",
      icon: "notes",
      label: "Textarea",
      required: false,
      validation: false
    },
    {
      type: "paragraph",
      icon: "short_text",
      label: "Paragraph",
      placeholder: "Type your text to display here only",
      required: false,
      validation: false
    },
    {
      type: "checkbox",
      required: true,
      validation: false,
      label: "Checkbox",
      icon: "check_box",
      description: "checkbox",
      inline: true,
      values: [
        {
          label: "Option 1",
          value: "option-1"
        },
        {
          label: "Option 2",
          value: "option-2"
        }
      ]
    },
    {
      type: "radio",
      icon: "radio_button_checked",
      label: "Radio",
      description: "",
      required: false,
      validation: false,
      values: [
        {
          label: "Option 1",
          value: "option-1"
        },
        {
          label: "Option 2",
          value: "option-2"
        }
      ]
    },
    {
      type: "select",
      icon: "list",
      label: "Select",
      description: "",
      placeholder: "",
      required: false,
      validation: false,
      values: [
        {
          label: "Option 1",
          value: "option-1"
        },
        {
          label: "Option 2",
          value: "option-2"
        },
        {
          label: "Option 3",
          value: "option-3"
        }
      ]
    },
    // {
    //   type: "image",
    //   icon: "image",
    //   label: "Image Upload",
    //   required: false,
    //   validation: false
    // },
    {
      type: "rating",
      icon: "star",
      label: "Rating",
      required: false,
      validation: false,
      max: 5
    },
    {
      type: "file",
      icon: "file_upload",
      label: "File Upload",
      required: false,
      validation: false,
      description: "Upload your file here",
      max: 10 * 1024 * 1024
    }
  ];

  public static defaultAccreditationTemplate = {
    uuid: "",
    name: "",
    label: "",
    description: "",
    sections: [
      {
        name: "requestedInformation",
        label: "Requested Information",
        description: "form description",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true
            },
            {
              label: "no",
              value: false
            }
          ]
        },
        attributes: [
          // {
          //   name: "Category",
          //   type: "radio",
          //   icon: "radio_button_checked",
          //   label: "Category",
          //   description: "",
          //   required: true,
          //   validation: false,
          //   values: [
          //     {
          //       label: "Yes",
          //       value: "option-1",
          //     },
          //     {
          //       label: "No",
          //       value: "option-2",
          //     },
          //   ],
          // },
          {
            name: "expiresAt",
            description: "",
            type: "date",
            icon: "",
            required: false,
            validation: false,
            regex: "",
            error_text: "",
            label: "Expires At",
            placeholder: "",
            class_name: "",
            min: 0,
            max: 0,
            default_value: null,
            value_arr: null,
            inline: false
          },
          {
            name: "licenceNumber",
            description: "",
            type: "number",
            icon: "",
            required: false,
            validation: false,
            regex: "",
            error_text: "",
            label: "Licence Number",
            placeholder: "",
            class_name: "",
            min: 0,
            max: 1000000,
            default_value: null,
            value_arr: null,
            inline: false
          },
          {
            name: "licensee",
            description: "",
            type: "text",
            icon: "",
            required: false,
            validation: false,
            regex: "",
            error_text: "",
            label: "Licensee",
            placeholder: "",
            class_name: "",
            min: 0,
            max: 0,
            default_value: null,
            value_arr: null,
            inline: false
          },
          {
            name: "classes",
            description: "",
            type: "select",
            icon: "",
            required: false,
            validation: false,
            values: [
              {
                label: "Option 1",
                value: "option-1"
              },
              {
                label: "Option 2",
                value: "option-2"
              },
              {
                label: "Option 3",
                value: "option-3"
              }
            ],
            regex: "",
            error_text: "",
            label: "Classes",
            placeholder: "",
            class_name: "",
            min: 0,
            max: 0,
            default_value: null,
            value_arr: null,
            inline: false
          },
          {
            name: "frontImage",
            description: "",
            type: "file",
            icon: "",
            required: false,
            validation: false,
            regex: "",
            error_text: "",
            label: "Front",
            placeholder: "",
            class_name: "",
            min: 0,
            max: 10485760,
            default_value: null,
            value_arr: null,
            inline: false
          }
          //     {
          //       name: "backImage",
          //       description: "",
          //       type: "file",
          //       icon: "",
          //       required: false,
          //       validation: false,
          //       regex: "",
          //       error_text: "",
          //       label: "Back",
          //       placeholder: "",
          //       class_name: "",
          //       min: 0,
          //       max: 10485760,
          //       default_value: null,
          //       value_arr: null,
          //       inline: false
          //     }
        ],
        multi: false,
        add_button_text: ""
      }
    ],
    created_by: "d5cda1f0-f8b0-48ab-89cb-08a85905a289",
    created_at: "2024-11-19T10:39:43.799Z",
    edited_by: "",
    last_edited_at: "0001-01-01T00:00:00Z",
    account_uuid: "8614ef5c-a452-491f-ac61-9db55e6393ad"
  };

  public static dataTables = {
    thsTableOperations: ["name", "description", "file", "category"],
    thsTableRequirements: ["name", "description", "file"],
    thsTableCriteria: ["category", "accreditation", "class", "quantity"],
    thsTableResources: ["name", "supplier", "listing type"],
    thsTableResourceHistory: [
      "resourceName",
      "date/time",
      "taskID",
      "class",
      "hourlyRate",
      "totalCost",
      "comments",
      "rating",
      "incidents"
    ],
    thsResourceWorkData: [
      "year",
      "all tasks",
      "accept",
      "decline",
      "pending",
      "rating"
    ],
    thsIncidentHistory: [
      "resource",
      "taskID",
      "date/time",
      "description",
      "status"
    ]
  };

  public static dataRegisterPage = {
    ["Australian driver's licence"]: [
      { control: "state of issue", label: "State of issue", type: "input" },
      { control: "licence number", label: "Licence number", type: "input" },
      { control: "expiry date", label: "Expiry date", type: "date" }
      // {control: 'image of the dl', label: 'Image of the DL', type: 'input'},
      // {control: 'front and back', label: 'Front and Back', type: 'input'}
    ],
    ["Medicare card"]: [
      { control: "medicare number", label: "Medicare number", type: "input" },
      {
        control: "individual card",
        label: "Individual card reference number",
        type: "input"
      },
      {
        control: "name",
        label: "Name as it appears on your card",
        type: "input"
      },
      { control: "card colour", label: "Card colour", type: "input" },
      { control: "validate date", label: "Card's valid date", type: "date" }
    ],
    ["Passport (all countries)"]: [
      { control: "country of issue", label: "Country of issue", type: "input" },
      { control: "passport number", label: "Passport number", type: "input" },
      { control: "expiry date", label: "Expiry date", type: "date" },
      {
        control: "birth",
        label: "Place of birth as stated on your passport",
        type: "date"
      },
      { control: "country", label: "Country of birth", type: "input" },
      {
        control: "name",
        label: "Family name at birth (Australian passports only)",
        type: "input"
      },
      {
        control: "",
        label:
          "Family name at citizenship (if you’re using an Australian passport but you were born overseas).",
        type: "input"
      }
    ]
  };
  public static controlsOfModal = [
    {
      id: "contacts",
      controls: [
        { name: "name", type: "input" },
        { name: "email", type: "input" },
        { name: "phone", type: "input" },
        { name: "title", type: "input" },
        { name: "department", type: "input" },
        { name: "address", type: "input" }
      ]
    },
    {
      id: "sub-accounts",
      controls: [
        { name: "type", type: "input" },
        { name: "abn", type: "input" },
        {
          name: "industry",
          type: "select",
          items: ["Security", "Hospitality"]
        },
        { name: "phone", type: "input" }
      ]
    }
  ];
}
